import { useOverlayContext, useStoreActions } from "../../contexts";
import { handleRequest } from "../../infra/utils";
import { useFeatureFlags } from "../useFeatureFlags";
const unvoidLoader = invoiceId => "unvoidInvoice-".concat(invoiceId);
export function useUnvoidInvoice() {
  const {
    UNVOID_INVOICE
  } = useFeatureFlags();
  const {
    api
  } = useStoreActions();
  const {
    startLoader,
    stopLoader,
    showErrorToast
  } = useOverlayContext();
  return {
    async startUnvoidInvoice(invoice) {
      if (!UNVOID_INVOICE) return;
      startLoader(unvoidLoader(invoice.id));
      const result = await handleRequest(api.invoice.unvoid(invoice.id));
      if (result.success) {
        // Here we wait for a pusher event to stop the loader and update the invoice.
      } else {
        showErrorToast(result.error.unvoidInvoiceErrorText(invoice), 'fpi-unvoid-invoice-error');
        stopLoader(unvoidLoader(invoice.id));
      }
    },
    async finishUnvoidInvoice(invoiceId) {
      stopLoader(unvoidLoader(invoiceId));
    }
  };
}